export default {
    blocksAvailableMutation(state, data){
        state.blocksAvailable = data;
    },
    blocksAvailableResumeMutation(state, data){
        state.blocksAvailableResume = data;
    },
    showLotPropertiesAvailableMutation(state, data){
        state.propertiesAvailable = data;
        state.propertiesAvailableBackup = data;
    },
    filterPropertiesAvailableMutation(state, data){
        state.propertiesAvailable = data;
    },
    changeblocksAvailableMutation(state, block){
        let obj = state.blocksAvailable;
        Object.entries(obj).forEach(([k,i]) => {
            if (i.text === block){
                obj[k].active = true;
            }else{
                obj[k].active = false;
            }
        })
        state.blocksAvailable = obj;
    },
    getPermissionsAllotmentMutation(state, data){
        console.log(state)
        console.log(data)
    }
}
